export const DEFAULT_TIMEOUT_MS = 10000;

// Only routes with server-side calls are included here. Routes where all API
// calls are client-side are omitted.

// Keys match the path segment: /api/v{n}/{key}/... or "presentation" for /presentation/api/...
export const INTERNAL_ROUTES: Record<string, string> = {
  product: 'http://webapi-product.webapi-default.svc.cluster.local',
  presentation: 'http://snowdon-api.presentation-default.svc.cluster.local',
  search: 'http://webapi-search.webapi-default.svc.cluster.local',
  shop: 'http://webapi-shop.webapi-default.svc.cluster.local',
  checkout: 'http://transactions-api.webapi-default.svc.cluster.local',
  sellerOnboarding: 'http://transactions-api.webapi-default.svc.cluster.local',
};

export const INTERNAL_ROUTE_HOSTS = Object.values(INTERNAL_ROUTES);
